import {
  GroupedSalesLocations,
  Location,
} from "@coworker/apprestructured/src/task-management/types/SalesLocation";

type LocationCategory = {
  categoryTranslationKey: string;
  // Not available for custom locations, which have no department.
  departmentName?: string;
};

function findLocationCategory(
  location: Location,
  filteredLocations: GroupedSalesLocations
): LocationCategory | undefined {
  const { slid, custom } = location;

  if (slid) {
    const homeAndPrimaryMatch = filteredLocations.homeAndPrimaryLocations.find(
      (loc) => loc.slid === slid
    );
    if (homeAndPrimaryMatch) {
      return {
        categoryTranslationKey: homeAndPrimaryMatch.isHome
          ? "homebaseString"
          : "salesLocationString",
        departmentName: homeAndPrimaryMatch.departmentName,
      };
    }

    const otherMatch = filteredLocations.otherSalesLocations.find(
      (loc) => loc.slid === slid
    );
    if (otherMatch) {
      return {
        categoryTranslationKey: "salesLocationString",
        departmentName: otherMatch.departmentName,
      };
    }

    const sgfMatch = filteredLocations.sgfLocations.find(
      (loc) => loc.slid === slid
    );
    if (sgfMatch) {
      return {
        categoryTranslationKey: "salesLocationString",
        departmentName: sgfMatch.departmentName,
      };
    }

    return undefined;
  }

  if (custom) {
    return { categoryTranslationKey: "customLocationString" };
  }

  return undefined;
}

/**
 * Returns e.g. "Homebase - Decoration" for the given location,
 * or undefined if it can't be matched (e.g. not loaded yet).
 */
export function getLocationCategoryLabel(
  location: Location | null,
  filteredLocations: GroupedSalesLocations,
  t: (key: string) => string
): string | undefined {
  if (!location) return undefined;

  const category = findLocationCategory(location, filteredLocations);
  if (!category) return undefined;

  const categoryLabel = t(category.categoryTranslationKey);
  return category.departmentName
    ? `${categoryLabel} - ${category.departmentName}`
    : categoryLabel;
}
